var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 113.12,
    cy: 86.32,
    r: 53.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.29,44.46s12.58,5.11,14.55,9-4.72,16.9-9,18.87S78.72,83,78.72,87.7s-3.54,6.68-9.83,1.18-8.43,2.39-8.43,2.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.43,98.7a33.26,33.26,0,0,0,16.5,5.11c9.83.4,12.58,10.22,12.58,23.59,0,0-.78,5.9,1.18,7.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.18,135.26S129,127,118,118.75s-1.57-23.19,2.75-27.91,25.94,5.11,23.59-7.07-18.42-1.89-20-1.5-2.42-3.61-2.81-8.33a34.23,34.23,0,0,1,.39-8.65l8.65-.78c4.32-.4,13.76-.79,14.54-4.33s-1.18-8.65-5.5-7.86,2.75-9.43,2.75-9.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.79,90.07s-17.89-1.59-15.92,5.49,12.32,10.12,12.32,10.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.61,42.07a44.91,44.91,0,0,0-.4,14.54s6.68,1.58,7.47-.39-2-4.8-1.18-8.65C129.68,42.07,125,37.35,122.61,42.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.11,134.44A67.68,67.68,0,1,1,64.4,38.73"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.48,
    y1: 124.28,
    x2: 168.23,
    y2: 142.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 56.1,
    y1: 29.57,
    x2: 75.17,
    y2: 48.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 109.38,
    y1: 154.94,
    x2: 109.38,
    y2: 189.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.45,
    y1: 189.99,
    x2: 131.67,
    y2: 189.99
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/GLOBE.885277583133284b585d962852fd8e91.svg";
export { ForwardRef as ReactComponent };